(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3753],{

/***/ 33730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 74152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(30381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 84091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SkeletonV2; },
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/types.ts
var types_animation = {
    WAVES: "waves",
    PULSE: "pulse"
};
var types_variant = {
    RECT: "rect",
    CIRCLE: "circle"
};

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(98903);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  will-change: opacity;\n  opacity: 0;\n  &.appear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n  &.disappear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 20px;\n  display: block;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 2s infinite ease-out;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  &:before {\n    content: "";\n    position: absolute;\n    background-image: linear-gradient(90deg, transparent, rgba(243, 243, 243, 0.5), transparent);\n    top: 0;\n    left: -150px;\n    height: 100%;\n    width: 150px;\n    animation: ',
        " 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var waves = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var AnimationWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-94de765-0"
}).withConfig({
    componentId: "sc-bfc8af08-0"
})(_templateObject2(), animationToolkit/* appearAnimation */.Oz, animationToolkit/* disappearAnimation */.a4);
var SkeletonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-1"
}).withConfig({
    componentId: "sc-bfc8af08-1"
})(_templateObject3(), index_esm/* layout */.bK, index_esm/* space */.Dh);
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-2"
}).withConfig({
    componentId: "sc-bfc8af08-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === types_variant.CIRCLE ? theme.radii.circle : theme.radii.small;
}, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* borderRadius */.E0);
var Pulse = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-3"
}).withConfig({
    componentId: "sc-bfc8af08-3"
})(_templateObject5(), pulse);
var Waves = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-4"
}).withConfig({
    componentId: "sc-bfc8af08-4"
})(_templateObject6(), waves);
var Skeleton = function Skeleton(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation"
    ]);
    if (animation === types_animation.WAVES) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread/* default */.Z)({
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread/* default */.Z)({
        variant: variant
    }, props));
};
var SkeletonV2 = function SkeletonV2(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, _isDataReady = _param.isDataReady, isDataReady = _isDataReady === void 0 ? false : _isDataReady, children = _param.children, wrapperProps = _param.wrapperProps, _skeletonTop = _param.skeletonTop, skeletonTop = _skeletonTop === void 0 ? "0" : _skeletonTop, _skeletonLeft = _param.skeletonLeft, skeletonLeft = _skeletonLeft === void 0 ? "0" : _skeletonLeft, width = _param.width, height = _param.height, mr = _param.mr, ml = _param.ml, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation",
        "isDataReady",
        "children",
        "wrapperProps",
        "skeletonTop",
        "skeletonLeft",
        "width",
        "height",
        "mr",
        "ml"
    ]);
    var animationRef = (0,react.useRef)(null);
    var skeletonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height,
        mr: mr,
        ml: ml
    }, wrapperProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
            features: features_animation/* domAnimation */.H,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                children: [
                    isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: animationRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(animationRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: children
                    }), "content"),
                    !isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            position: "absolute",
                            top: skeletonTop,
                            left: skeletonLeft
                        },
                        ref: skeletonRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(skeletonRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: animation === types_animation.WAVES ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        }))
                    }), "skeleton")
                ]
            })
        })
    }));
};
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);


/***/ }),

/***/ 94528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.29006 15.88L13.1701 12L9.29006 8.12001C8.90006 7.73001 8.90006 7.10001 9.29006 6.71001C9.68006 6.32001 10.3101 6.32001 10.7001 6.71001L15.2901 11.3C15.6801 11.69 15.6801 12.32 15.2901 12.71L10.7001 17.3C10.3101 17.69 9.68006 17.69 9.29006 17.3C8.91006 16.91 8.90006 16.27 9.29006 15.88Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 65044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A8": function() { return /* binding */ getAdd; },
/* harmony export */   "FH": function() { return /* binding */ toFixed; },
/* harmony export */   "Pn": function() { return /* binding */ getFullNum; },
/* harmony export */   "U1": function() { return /* binding */ formatBigNumberToFixed; },
/* harmony export */   "az": function() { return /* binding */ formatBalance; },
/* harmony export */   "b9": function() { return /* binding */ truncateHasZero; },
/* harmony export */   "bW": function() { return /* binding */ truncateZero; },
/* harmony export */   "bd": function() { return /* binding */ formatEffectiveNumber; },
/* harmony export */   "cy": function() { return /* binding */ getSub; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "m8": function() { return /* binding */ formatEffectiveNumberSix; },
/* harmony export */   "sR": function() { return /* binding */ getRes; },
/* harmony export */   "w$": function() { return /* binding */ formatFixedNumber; }
/* harmony export */ });
/* unused harmony exports getDecimalAmount, getBalanceAmount, getBalanceNumber, getFullDisplayBalance, formatNumber, formatBigNumber, formatLocalisedCompactNumber, formatLpBalance, truncate, formatEffectiveNumber2 */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70794);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2593);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61744);
/* harmony import */ var _noahswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65208);
/* harmony import */ var _getFullDecimalMultiplier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44356);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74152);
/* harmony import */ var moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment_locale_zh_tw__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33730);
/* harmony import */ var moment_locale_ko__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment_locale_ko__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable */ 






 // 中文繁体
 // 韩文
// 加法函数
function getAdd(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.plus(num2).toString();
}
// 减法函数
function getSub(a, b) {
    var num1 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(a);
    var num2 = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(b);
    return num1.minus(num2).toString();
}
function getTime(value) {
    return moment__WEBPACK_IMPORTED_MODULE_3___default()(value).format("YYYY-MM-DD HH:mm:ss");
//   const zone = moment().utcOffset() / 60; // 时区
//   const formattedTime = moment(value).add(0 + zone, 'hours');
//   const codeFromStorage = getLanguageCodeFromLS() // current language code
//   // console.log('当前缓存的语言', codeFromStorage)
//   if (codeFromStorage === 'zh-TW') {
//     formattedTime.locale('zh-tw');
//     // return formattedTime.format("MMMDo, A hh:mm, dddd");
//     return formattedTime.format("YYYY年MMMD Ah:mm");
//   } else if (codeFromStorage === 'ko-KR') {
//     formattedTime.locale('ko');
//     // return formattedTime.format("hh:mm A, dddd, MMM D");
//     return formattedTime.format("hh:mm A, YYYY MMM D");
//   } else {
//     formattedTime.locale('en');
//     // return formattedTime.format("hh:mm A, ddd, MMM D");
//     return formattedTime.format("MMM D, YYYY, h:mm A");
//   }
//   // return moment(time).add(0 + zone, 'hours').format("hh:mm A, dddd, MMM. D")
// // },
// // return moment(value).format('MMM D, YYYY, h:mm A')
}
function formatBalance(price, precision) {
    var realPrice = formatBigNumber(price);
    var scaledPrice = Number(realPrice) * Math.pow(10, 18);
    var formattedPrice = (scaledPrice / Math.pow(10, precision)).toFixed(precision);
    return formattedPrice;
}
/**
 * Take a formatted amount, e.g. 15 EOS and convert it to full decimal value, e.g. 15000000000000000
 */ var getDecimalAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).times(getFullDecimalMultiplier(decimals));
};
var getBalanceAmount = function(amount) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return new BigNumber(amount).dividedBy(getFullDecimalMultiplier(decimals));
};
/**
 * This function is not really necessary but is used throughout the site.
 */ var getBalanceNumber = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    return getBalanceAmount(balance, decimals).toNumber();
};
var getFullDisplayBalance = function(balance) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, displayDecimals = arguments.length > 2 ? arguments[2] : void 0;
    return getBalanceAmount(balance, decimals).toFixed(displayDecimals);
};
/**
 * Don't use the result to convert back to number.
 * It uses undefined locale which uses host language as a result.
 * Languages have different decimal separators which results in inconsistency when converting back this result to number.
 */ var formatNumber = function(number) {
    var minPrecision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, maxPrecision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var options = {
        minimumFractionDigits: minPrecision,
        maximumFractionDigits: maxPrecision
    };
    return number.toLocaleString(undefined, options);
};
/**
 * Method to format the display of wei given an EthersBigNumber object
 * Note: does NOT round
 */ var formatBigNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var remainder = number.mod(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(10).pow(decimals - displayDecimals));
    return (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number.sub(remainder), decimals);
};
/**
 * Method to format the display of wei given an EthersBigNumber object with toFixed
 * Note: rounds
 */ var formatBigNumberToFixed = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    var formattedString = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_7__.formatUnits)(number, decimals);
    return (+formattedString).toFixed(displayDecimals);
};
/**
 * Formats a FixedNumber like BigNumber
 * i.e. Formats 9763410526137450427.1196 into 9.763 (3 display decimals)
 */ var formatFixedNumber = function(number) {
    var displayDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18, decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 18;
    // Remove decimal
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(number.toString().split("."), 1), leftSide = ref[0];
    return formatBigNumber(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_6__/* .BigNumber.from */ .O$.from(leftSide), displayDecimals, decimals);
};
var formatLocalisedCompactNumber = function(number) {
    var codeFromStorage = getLanguageCodeFromLS();
    var isClient = "object" === "object";
    var isSupported = window === null || window === void 0 ? void 0 : window.Intl;
    // For clients do not support Intl, just return number
    if (isClient && !isSupported) {
        return "".concat(number);
    }
    return new Intl.NumberFormat(codeFromStorage, {
        notation: "compact",
        compactDisplay: "long",
        maximumSignificantDigits: 2
    }).format(number);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (formatLocalisedCompactNumber)));
var formatLpBalance = function(balance) {
    var stakedBalanceBigNumber = getBalanceAmount(balance);
    if (stakedBalanceBigNumber.gt(0) && stakedBalanceBigNumber.lt(0.00001)) {
        return "< 0.00001";
    }
    return stakedBalanceBigNumber.toFixed(5, BigNumber.ROUND_DOWN);
};
// 截取，只保留有效位数
var truncate = function(num, decimals) {
    var multiplier = Math.pow(10, decimals);
    return Math.floor(num * multiplier) / multiplier;
};
// 截取，包含0
var truncateZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1, index + 1 + decimals);
        return mainPart + "." + decimalPart.padEnd(decimals, "0");
    } else {
        return str + "." + "0".repeat(decimals);
    }
};
// 截取有效位数，从小数部分非零数字开始计数
var truncateHasZero = function(num, decimals) {
    var str = num.toString();
    var index = str.indexOf(".");
    if (index >= 0) {
        var mainPart = str.slice(0, index);
        var decimalPart = str.slice(index + 1);
        var nonZeroIndex = 0;
        while(nonZeroIndex < decimalPart.length && decimalPart[nonZeroIndex] === "0"){
            nonZeroIndex++;
        }
        var truncatedDecimalPart = decimalPart.slice(0, nonZeroIndex + decimals);
        return mainPart + "." + truncatedDecimalPart;
    } else {
        return str;
    }
};
// 返回3位或指定有效位小数，例如：200.000输出200，200.000123输出200.000123
var formatEffectiveNumber = function(num) {
    var n = Number(num);
    var str = n.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1 && str.length > decimalIndex + 4) {
        return str.slice(0, decimalIndex + 4);
    } else {
        return str;
    }
};
var formatEffectiveNumberSix = function(decimal) {
    var decimalString = decimal.toString();
    var match = decimalString.match(/^0\.0*([1-9]\d{0,5})/);
    if (match) {
        return match[0];
    } else {
        return Number(decimal).toPrecision(8);
    }
};
var formatEffectiveNumber2 = function(num, decimal) {
    var str = num.toString();
    var decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1) {
        var decimals = str.slice(decimalIndex + 1);
        var nonZeroIndex = decimals.search(/[^0]/) //查找第一个非零小数的位置
        ;
        if (nonZeroIndex !== -1) {
            //保留指定有效位数的小数
            var effectiveDecimals = decimals.slice(nonZeroIndex, nonZeroIndex + decimal);
            return str.slice(0, decimalIndex + 1) + effectiveDecimals;
        }
    }
    return str;
};
// 取消四舍五入
var getRes = function(num) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    // if (Number(num) === Math.floor(num)) return Math.floor(num);
    var res = [];
    var addNum = 0;
    // eslint-disable-next-line no-param-reassign
    num += "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(num.split("."), 2), zs = ref[0], xs = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(/^(-?)(\d+\.\d+|\d+)$/.exec(zs), 3), symbol = ref1[1], zsNum = ref1[2];
    if (!xs) return num;
    for(var i = 0; i < xs.length; i++){
        var ele = xs[i];
        // eslint-disable-next-line
        if (ele != 0) {
            // if (xs[i + digit] && xs[i + digit] > 4) {
            //   addNum = 1
            //   for (let j = i + (digit - 1); j >= 0; j--) {
            //     if (Number(xs[j]) + addNum === 10) res[j] = '0'
            //     else {
            //       res[j] = Number(xs[j]) + addNum
            //       addNum = 0
            //     }
            //   }
            // } else {
            for(var k = i; k <= i + (digit - 1); k++){
                res[k] = xs[k];
            }
            break;
        } else res[i] = xs[i];
    }
    return getFullNum(Number("".concat(symbol + (Number(zsNum) + addNum), ".").concat(res.join(""))));
};
var getFullNum = function(num) {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return num;
    }
    // 处理不需要转换的数字
    var str = String(num);
    if (!/e/i.test(str)) {
        return num;
    }
    return Number(num).toFixed(18).replace(/\.?0+$/, "");
};
var toFixed = function(value, precision) {
    var numberValue = Number(value);
    return numberValue.toFixed(precision);
};


/***/ }),

/***/ 45131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79331);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19838);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_EOS */ .Mb)) {
            return _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_EOS */ .Mb));
        }
        return _noahswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ }),

/***/ 3753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Swap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(79331);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var exchange = __webpack_require__(42658);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(56245);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(72234);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var localization_src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var constants_exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(45131);
;// CONCATENATED MODULE: ./src/config/constants/warningTokens.ts

var evmWarningTokens = {
    pokemoney: new src/* Token */.WU(src/* ChainId.EVM */.a_.EVM, "0x32ff5b4C3B1744F0344D96fA2f87799Ed2805749", 18, "PMY", "Pokemoney Coin", ""),
    free: new src/* Token */.WU(src/* ChainId.EVM */.a_.EVM, "0x880BCe9321c79cAc1D290De6d31DDE722C606165", 8, "FREE", "Freedom Protocol Token", ""),
    safemoon: new src/* Token */.WU(src/* ChainId.EVM */.a_.EVM, "0x8076C74C5e3F5852037F31Ff0093Eeb8c8ADd8D3", 9, "SAFEMOON", "Safemoon Token", "https://safemoon.net/")
};
var evmTestnetWarningTokens = {};

;// CONCATENATED MODULE: ./src/config/constants/swapWarningTokens.ts

// const { bondly, itam, ccar, bttold } = evmTokens
var pokemoney = evmWarningTokens.pokemoney, free = evmWarningTokens.free, safemoon = evmWarningTokens.safemoon;
var SwapWarningTokens = {
    // safemoon,
    // bondly,
    // itam,
    // ccar,
    // bttold,
    // pokemoney,
    free: free
};
/* harmony default export */ var swapWarningTokens = (SwapWarningTokens);

;// CONCATENATED MODULE: ./src/utils/shouldShowSwapWarning.ts

var shouldShowSwapWarning_swapWarningTokens = Object.values(swapWarningTokens);
var shouldShowSwapWarning = function(swapCurrency) {
    return shouldShowSwapWarning_swapWarningTokens.some(function(warningToken) {
        return warningToken.equals(swapCurrency);
    });
};
/* harmony default export */ var utils_shouldShowSwapWarning = (shouldShowSwapWarning);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/index.ts + 38 modules
var state = __webpack_require__(81002);
;// CONCATENATED MODULE: ./src/state/swap/useSwapActionHandlers.ts



function useSwapActionHandlers() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var onSwitchTokens = (0,react.useCallback)(function() {
        dispatch((0,actions/* switchCurrencies */.KS)());
    }, [
        dispatch
    ]);
    var onCurrencySelection = (0,react.useCallback)(function(field, currency) {
        dispatch((0,actions/* selectCurrency */.j)({
            field: field,
            currencyId: (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency.address : (currency === null || currency === void 0 ? void 0 : currency.isNative) ? currency.symbol : ""
        }));
    }, [
        dispatch
    ]);
    var onUserInput = (0,react.useCallback)(function(field, typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRecipient = (0,react.useCallback)(function(recipient) {
        dispatch((0,actions/* setRecipient */.He)({
            recipient: recipient
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRecipient: onChangeRecipient
    };
}

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Swap/hooks/useRefreshBlockNumber.ts



var useRefreshBlockNumber = function() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setFetch = ref[1];
    var refreshBlockNumber = (0,react.useCallback)(function() {
        if (!isLoading) {
            setFetch(true);
        }
    }, [
        isLoading
    ]);
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    (0,react.useEffect)(function() {
        if (!isLoading) return;
        mutate([
            "blockNumber",
            chainId
        ]);
        // setTimeout is used to demonstrate the loading
        // because the real loading state occurs on multicall state
        // we don't know when the fetch is finished.
        setTimeout(function() {
            return setFetch(false);
        }, 500);
    }, [
        mutate,
        isLoading,
        chainId
    ]);
    return {
        refreshBlockNumber: refreshBlockNumber,
        isLoading: isLoading
    };
};
/* harmony default export */ var hooks_useRefreshBlockNumber = (useRefreshBlockNumber);

// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx
var CurrencyInputPanel = __webpack_require__(71372);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Icons_Error = __webpack_require__(44700);
;// CONCATENATED MODULE: ./src/views/Swap/components/styleds.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          :hover {\n            cursor: pointer;\n            opacity: 0.8;\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 22px;\n  width: 22px;\n  background: transparent;\n  /* background-color: ",
        "; */\n  border: none;\n  border-radius: 50%;\n  padding: 0.2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin-left: 0.4rem;\n  cursor: pointer;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n\n  /* :hover {\n    background-color: ",
        ";\n  } */\n  /* :focus {\n    background-color: ",
        ";\n    outline: none;\n  } */\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 220px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 0.825rem;\n  width: 100%;\n  padding: 3rem 1.25rem 1rem 1rem;\n  margin-top: -2rem;\n  color: ",
        ";\n  z-index: -1;\n  p {\n    padding: 0;\n    margin: 0;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  border-radius: 12px;\n  min-width: 48px;\n  height: 48px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem;\n  border-radius: 12px;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4c1e61ab-0"
})(_templateObject());
var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c1e61ab-1"
})(_templateObject2(), function(param) {
    var clickable = param.clickable;
    return clickable ? (0,styled_components_browser_esm/* css */.iv)(_templateObject1()) : null;
});
var ErrorText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-4c1e61ab-2"
})(_templateObject3(), function(param) {
    var theme = param.theme, severity = param.severity;
    return severity === 3 || severity === 4 ? theme.colors.failure : severity === 2 ? theme.colors.warning : severity === 1 ? theme.colors.text : theme.colors.success;
});
var StyledBalanceMaxMini = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-4c1e61ab-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var TruncatedText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    ellipsis: true
}).withConfig({
    componentId: "sc-4c1e61ab-4"
})(_templateObject5());
var SwapCallbackErrorInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c1e61ab-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure, "33");
}, function(param) {
    var theme = param.theme;
    return theme.colors.failure;
});
var SwapCallbackErrorInnerAlertTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4c1e61ab-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure, "33");
});
function SwapCallbackError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapCallbackErrorInner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackErrorInnerAlertTriangle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error
            })
        ]
    });
}
var SwapShowAcceptChanges = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-4c1e61ab-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.warning, "33");
});

;// CONCATENATED MODULE: ./src/views/Swap/components/TradePrice.tsx




function TradePrice(param) {
    var price = param.price, showInverted = param.showInverted, setShowInverted = param.setShowInverted;
    var ref, ref1, ref2, ref3, ref4;
    var formattedPrice = !showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "1 ".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " = ").concat((0,formatInfoNumbers/* formatNumber */.uf)(formattedPrice, formattedPrice), " ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "1 ".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " = ").concat((0,formatInfoNumbers/* formatNumber */.uf)(formattedPrice, formattedPrice), " ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: {
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            fontSize: "14px"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/small-img/replace.png",
                        width: 14,
                        alt: ""
                    })
                })
            ]
        }) : "-"
    });
}

// EXTERNAL MODULE: ./src/components/App/index.tsx + 2 modules
var App = __webpack_require__(72609);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 1 modules
var useApproveCallback = __webpack_require__(50165);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/utils/truncateHash.ts
var truncateHash = __webpack_require__(53467);
// EXTERNAL MODULE: ./src/config/constants/index.ts + 2 modules
var constants = __webpack_require__(68274);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
;// CONCATENATED MODULE: ./src/utils/isZero.ts
/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */ function isZero(hexNumberString) {
    return /^0x0*$/.test(hexNumberString);
}

// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts + 1 modules
var useTransactionDeadline = __webpack_require__(3620);
;// CONCATENATED MODULE: ./src/hooks/useSwapCallArguments.ts







/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName
 */ function useSwapCallArguments(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var recipient = recipientAddress === null ? account : recipientAddress;
    var deadline = (0,useTransactionDeadline/* default */.Z)();
    var contract = (0,exchange/* useRouterContract */.Ti)();
    return (0,react.useMemo)(function() {
        if (!trade || !recipient || !account || !chainId || !deadline) return [];
        if (!contract) {
            return [];
        }
        var swapMethods = [];
        swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
            feeOnTransfer: false,
            allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), constants_exchange/* BIPS_BASE */.PM),
            recipient: recipient,
            deadline: deadline.toNumber()
        }));
        if (trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT) {
            swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
                feeOnTransfer: true,
                allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), constants_exchange/* BIPS_BASE */.PM),
                recipient: recipient,
                deadline: deadline.toNumber()
            }));
        }
        return swapMethods.map(function(parameters) {
            return {
                parameters: parameters,
                contract: contract
            };
        });
    }, [
        account,
        allowedSlippage,
        chainId,
        contract,
        deadline,
        recipient,
        trade
    ]);
}

// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(42808);
;// CONCATENATED MODULE: ./src/hooks/useSwapCallback.ts

















var SwapCallbackState;
(function(SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
// returns a function that will execute a swap, if the parameters are all valid
// and the user has approved the slippage adjusted input amount for the trade
function useSwapCallback(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    var swapCalls = useSwapCallArguments(trade, allowedSlippage, recipientAddress);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var recipient = recipientAddress === null ? account : recipientAddress;
    return (0,react.useMemo)(function() {
        if (!trade || !account || !chainId) {
            return {
                state: SwapCallbackState.INVALID,
                callback: null,
                error: "Missing dependencies"
            };
        }
        if (!recipient) {
            if (recipientAddress !== null) {
                return {
                    state: SwapCallbackState.INVALID,
                    callback: null,
                    error: "Invalid recipient"
                };
            }
            return {
                state: SwapCallbackState.LOADING,
                callback: null,
                error: null
            };
        }
        return {
            state: SwapCallbackState.VALID,
            callback: function() {
                var _onSwap = (0,_async_to_generator/* default */.Z)(function() {
                    var _contract, estimatedCalls, successfulEstimation, errorCalls, _call, contract, _parameters, methodName, args, value, gasEstimate;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(swapCalls.map(function(call) {
                                        var _estimateGas;
                                        var _parameters = call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, contract = call.contract;
                                        var options = !value || isZero(value) ? {} : {
                                            value: value
                                        };
                                        console.log("args", args);
                                        return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(args).concat([
                                            options
                                        ])).then(function(gasEstimate) {
                                            return {
                                                call: call,
                                                gasEstimate: gasEstimate
                                            };
                                        }).catch(function(gasError) {
                                            var _callStatic;
                                            console.error("Gas estimate failed, trying eth_call to extract error", call);
                                            return (_callStatic = contract.callStatic)[methodName].apply(_callStatic, (0,_to_consumable_array/* default */.Z)(args).concat([
                                                options
                                            ])).then(function(result) {
                                                console.error("Unexpected successful call after failed estimate gas", call, gasError, result);
                                                return {
                                                    call: call,
                                                    error: t("Unexpected issue with estimating the gas. Please try again.")
                                                };
                                            }).catch(function(callError) {
                                                console.error("Call threw error", call, callError);
                                                return {
                                                    call: call,
                                                    error: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(callError, t)
                                                };
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                estimatedCalls = _state.sent();
                                successfulEstimation = estimatedCalls.find(function(el, ix, list) {
                                    return "gasEstimate" in el && (ix === list.length - 1 || "gasEstimate" in list[ix + 1]);
                                });
                                if (!successfulEstimation) {
                                    errorCalls = estimatedCalls.filter(function(call) {
                                        return "error" in call;
                                    });
                                    if (errorCalls.length > 0) throw new Error(errorCalls[errorCalls.length - 1].error);
                                    throw new Error(t("Unexpected error. Could not estimate gas for the swap."));
                                }
                                _call = successfulEstimation.call, contract = _call.contract, _parameters = _call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, gasEstimate = successfulEstimation.gasEstimate;
                                return [
                                    2,
                                    (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(args).concat([
                                        (0,_object_spread/* default */.Z)({
                                            gasLimit: (0,utils/* calculateGasMargin */.yC)(gasEstimate),
                                            gasPrice: gasPrice
                                        }, value && !isZero(value) ? {
                                            value: value,
                                            from: account
                                        } : {
                                            from: account
                                        })
                                    ])).then(function(response) {
                                        var inputSymbol = trade.inputAmount.currency.symbol;
                                        var outputSymbol = trade.outputAmount.currency.symbol;
                                        var pct = (0,exchange/* basisPointsToPercent */.P4)(allowedSlippage);
                                        var inputAmount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.inputAmount.toSignificant(3) : trade.maximumAmountIn(pct).toSignificant(3);
                                        var outputAmount = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? trade.outputAmount.toSignificant(3) : trade.minimumAmountOut(pct).toSignificant(3);
                                        var base = "Swap ".concat(trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? "max." : "", " ").concat(inputAmount, " ").concat(inputSymbol, " for ").concat(trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "min." : "", " ").concat(outputAmount, " ").concat(outputSymbol);
                                        var recipientAddressText = recipientAddress && (0,utils/* isAddress */.UJ)(recipientAddress) ? (0,truncateHash/* default */.Z)(recipientAddress) : recipientAddress;
                                        var withRecipient = recipient === account ? base : "".concat(base, " to ").concat(recipientAddressText);
                                        var translatableWithRecipient = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? recipient === account ? "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol%" : "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol% to %recipientAddress%" : recipient === account ? "Trade %num1% %coin1% to get %num2% %coin2%" : "Swap %inputAmount% %inputSymbol% for min. %outputAmount% %outputSymbol% to %recipientAddress%";
                                        addTransaction(response, {
                                            summary: withRecipient,
                                            translatableSummary: {
                                                text: translatableWithRecipient,
                                                data: (0,_object_spread/* default */.Z)({
                                                    num1: inputAmount,
                                                    coin1: inputSymbol,
                                                    num2: outputAmount,
                                                    coin2: outputSymbol
                                                }, recipient !== account && {
                                                    recipientAddress: recipientAddressText
                                                })
                                            },
                                            type: "swap"
                                        });
                                        return response.hash;
                                    }).catch(function(error) {
                                        // if the user rejected the tx, pass this along
                                        if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                            throw new Error("Transaction rejected.");
                                        } else {
                                            // otherwise, the error was unexpected and we need to convey that
                                            console.error("Swap failed", error, methodName, args, value);
                                            throw new Error(t("Swap failed: %message%", {
                                                message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(error, t, "swap")
                                            }));
                                        }
                                    })
                                ];
                        }
                    });
                });
                function onSwap() {
                    return _onSwap.apply(this, arguments);
                }
                return onSwap;
            }(),
            error: null
        };
    }, [
        trade,
        account,
        chainId,
        recipient,
        recipientAddress,
        swapCalls,
        gasPrice,
        t,
        addTransaction,
        allowedSlippage
    ]);
}

// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(61905);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
;// CONCATENATED MODULE: ./src/hooks/useWrapCallback.ts











var WrapType;
(function(WrapType) {
    WrapType[WrapType["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    WrapType[WrapType["WRAP"] = 1] = "WRAP";
    WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));
var NOT_APPLICABLE = {
    wrapType: WrapType.NOT_APPLICABLE
};
/**
 * Given the selected input and output currency, return a wrap callback
 * @param inputCurrency the selected input currency
 * @param outputCurrency the selected output currency
 * @param typedValue the user input value
 */ function useWrapCallback(inputCurrency, outputCurrency, typedValue) {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var weosContract = (0,useContract/* useWNativeContract */.vR)();
    var balance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, inputCurrency);
    // we can always parse the amount typed as the input currency, since wrapping is 1:1
    var inputAmount = (0,react.useMemo)(function() {
        return (0,tryParseAmount/* default */.Z)(typedValue, inputCurrency);
    }, [
        inputCurrency,
        typedValue
    ]);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    return (0,react.useMemo)(function() {
        var ref, ref1;
        if (!weosContract || !chainId || !inputCurrency || !outputCurrency) return NOT_APPLICABLE;
        var sufficientBalance = inputAmount && balance && !balance.lessThan(inputAmount);
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative) && ((ref = src/* WNATIVE */.FX[chainId]) === null || ref === void 0 ? void 0 : ref.equals(outputCurrency))) {
            return {
                wrapType: WrapType.WRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, num1, coin1, coin2, num2, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(weosContract, "deposit", undefined, {
                                        value: "0x".concat(inputAmount.quotient.toString(16))
                                    })
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                num1 = inputAmount.toSignificant(6);
                                coin1 = inputCurrency.symbol;
                                coin2 = src/* WNATIVE */.FX[chainId].symbol;
                                num2 = inputAmount.toSignificant(6);
                                addTransaction(txReceipt, {
                                    summary: "Wrap ".concat(num1, " ").concat(coin1, " to ").concat(coin2),
                                    translatableSummary: {
                                        text: "Wrap %num1% %coin1% to %num2% %coin2%",
                                        data: {
                                            num1: num1,
                                            coin1: coin1,
                                            num2: num2,
                                            coin2: coin2
                                        }
                                    },
                                    type: "wrap"
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not deposit", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        if (((ref1 = src/* WNATIVE */.FX[chainId]) === null || ref1 === void 0 ? void 0 : ref1.equals(inputCurrency)) && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isNative)) {
            return {
                wrapType: WrapType.UNWRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, amount, wrap, native, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(weosContract, "withdraw", [
                                        "0x".concat(inputAmount.quotient.toString(16))
                                    ])
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                amount = inputAmount.toSignificant(6);
                                wrap = src/* WNATIVE */.FX[chainId].symbol;
                                native = outputCurrency.symbol;
                                addTransaction(txReceipt, {
                                    summary: "Unwrap ".concat(amount, " ").concat(wrap, " to ").concat(native),
                                    translatableSummary: {
                                        text: "Unwrap %amount% %wrap% to %native%",
                                        data: {
                                            amount: amount,
                                            wrap: wrap,
                                            native: native
                                        }
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not withdraw", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        return NOT_APPLICABLE;
    }, [
        weosContract,
        chainId,
        inputCurrency,
        outputCurrency,
        t,
        inputAmount,
        balance,
        addTransaction,
        callWithGasPrice
    ]);
}

// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 18 modules
var swap_hooks = __webpack_require__(12788);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(7010);
// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./src/components/ResultModal/index.tsx
var ResultModal = __webpack_require__(28393);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts + 1 modules
var useTheme = __webpack_require__(25628);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/Acknowledgement.tsx




var Acknowledgement = function(param) {
    var handleContinueClick = param.handleContinueClick;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isConfirmed = ref[0], setIsConfirmed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            name: "confirmed",
                            type: "checkbox",
                            checked: isConfirmed,
                            onChange: function() {
                                return setIsConfirmed(!isConfirmed);
                            },
                            scale: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "10px",
                            style: {
                                userSelect: "none"
                            },
                            children: t("noah163")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !isConfirmed,
                    onClick: handleContinueClick,
                    children: t("noah164")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_Acknowledgement = (Acknowledgement);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/FREEWarning.tsx



var FREEWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            children: t("Risk Warning: This token is subject to high price risk. Please do your own research before trading this token. Please also note that as of 24 June 2022 there is also a reflection fee for every transfer of FREE ranging from 2.5 to 5% per trade/transfer.")
        })
    });
};
/* harmony default export */ var SwapWarningModal_FREEWarning = (FREEWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/index.tsx


function SwapWarningModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 440px;\n"
    ]);
    SwapWarningModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapWarningModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  justify-content: flex-start;\n"
    ]);
    SwapWarningModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-f1c4cf2b-0"
})(SwapWarningModal_templateObject());
var MessageContainer = (0,styled_components_browser_esm/* default */.ZP)(Message/* default */.Z).withConfig({
    componentId: "sc-f1c4cf2b-1"
})(SwapWarningModal_templateObject1());
var SwapWarningModal = function(param) {
    var swapCurrency = param.swapCurrency, onDismiss = param.onDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var TOKEN_WARNINGS = // [SwapWarningTokensConfig.safemoon.address]: {
    //   symbol: SwapWarningTokensConfig.safemoon.symbol,
    //   component: <SafemoonWarning />,
    // },
    // [SwapWarningTokensConfig.bondly.address]: {
    //   symbol: SwapWarningTokensConfig.bondly.symbol,
    //   component: <BondlyWarning />,
    // },
    // [SwapWarningTokensConfig.itam.address]: {
    //   symbol: SwapWarningTokensConfig.itam.symbol,
    //   component: <ItamWarning />,
    // },
    // [SwapWarningTokensConfig.ccar.address]: {
    //   symbol: SwapWarningTokensConfig.ccar.symbol,
    //   component: <CcarWarning />,
    // },
    // [SwapWarningTokensConfig.bttold.address]: {
    //   symbol: SwapWarningTokensConfig.bttold.symbol,
    //   component: <BTTWarning />,
    // },
    // [SwapWarningTokensConfig.pokemoney.address]: {
    //   symbol: SwapWarningTokensConfig.pokemoney.symbol,
    //   component: <RugPullWarning />,
    // },
    (0,_define_property/* default */.Z)({}, swapWarningTokens.free.address, {
        symbol: swapWarningTokens.free.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_FREEWarning, {})
    });
    var SWAP_WARNING = TOKEN_WARNINGS[swapCurrency.address];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        $minWidth: "280px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalHeader */.xB, {
                background: theme.colors.gradients.cardHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    p: "12px 24px",
                    children: t("Notice for trading %symbol%", {
                        symbol: SWAP_WARNING.symbol
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageContainer, {
                        variant: "warning",
                        mb: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: SWAP_WARNING.component
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_Acknowledgement, {
                        handleContinueClick: onDismiss
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SwapWarningModal = (SwapWarningModal);

;// CONCATENATED MODULE: ./src/views/Swap/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n  /* padding: 0 24px; */\n\n  // ",
        " {\n  //   padding: 0 40px;\n  // }\n\n  // ",
        " {\n  //   ",
        ";\n  // }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* width: 360px; */\n  /* max-width: 360px; */\n  width: 100%;\n  ",
        " {\n    width: 436px !important;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwapContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cce4c768-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, function(param) {
    var $isChartExpanded = param.$isChartExpanded;
    return $isChartExpanded ? "padding: 0 120px" : "padding: 0 40px";
});
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-cce4c768-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});

// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(45341);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx + 4 modules
var GlobalSettings = __webpack_require__(8742);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var types = __webpack_require__(47431);
;// CONCATENATED MODULE: ./src/views/Swap/components/CurrencyInputHeader.tsx


function CurrencyInputHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 24px 0 24px;\n  width: 100%;\n"
    ]);
    CurrencyInputHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyInputHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #4c4c4c;\n  font-size: 14px;\n  margin-right: 5px;\n"
    ]);
    CurrencyInputHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencyInputHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.rotating {\n    animation: rotate 1s linear;\n  }\n  @keyframes rotate {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n"
    ]);
    CurrencyInputHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






// import { RowBetween } from 'components/Layout/Row'


var CurrencyInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-337ea6d2-0"
})(CurrencyInputHeader_templateObject());
var CurrencyInputHeader_Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-337ea6d2-1"
})(CurrencyInputHeader_templateObject1());
var RotatingImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-337ea6d2-2"
})(CurrencyInputHeader_templateObject2());
var CurrencyInputHeader = function(param) {
    var title = param.title, allowedSlippage = param.allowedSlippage, hasAmount = param.hasAmount, onRefreshPrice = param.onRefreshPrice;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    var imgRef = (0,react.useRef)(null);
    var ref1 // 旋转状态
     = (0,react.useState)(false), isRotating = ref1[0], setIsRotating = ref1[1];
    // const handleOnClick = useCallback(() => onRefreshPrice?.(), [onRefreshPrice])
    var handleOnClick = (0,react.useCallback)(function() {
        var ref;
        onRefreshPrice === null || onRefreshPrice === void 0 ? void 0 : onRefreshPrice();
        if (!hasAmount) return;
        setIsRotating(true) // 开始旋转
        ;
        (ref = imgRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("animationend", function() {
            return setIsRotating(false);
        }) // 动画结束停止旋转
        ;
    }, [
        onRefreshPrice
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexDirection: "column",
                    alignItems: "flex",
                    mr: 18,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                            show: expertMode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings/* default */.Z, {
                                color: "textSubtle",
                                mr: "0",
                                mode: types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            scale: "sm",
                            onClick: handleOnClick,
                            style: {
                                cursor: hasAmount ? "pointer" : "no-drop"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingImage, {
                                ref: imgRef,
                                src: "/images/small-img/refresh.png",
                                width: 22,
                                alt: "",
                                className: isRotating ? "rotating" : ""
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CurrencyInputHeader = (CurrencyInputHeader);

// EXTERNAL MODULE: ./src/components/SearchModal/types.ts
var SearchModal_types = __webpack_require__(40330);
// EXTERNAL MODULE: ./src/utils/replaceBrowserHistory.ts
var replaceBrowserHistory = __webpack_require__(59225);
// EXTERNAL MODULE: ./src/utils/currencyId.ts
var currencyId = __webpack_require__(28996);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(94528);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapRoute.tsx




/* harmony default export */ var SwapRoute = (/*#__PURE__*/(0,react.memo)(function SwapRoute(param) {
    var trade = param.trade;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexWrap: "wrap",
        justifyContent: "flex-end",
        alignItems: "center",
        children: trade.route.path.map(function(token, i, path) {
            var isLastItem = i === path.length - 1;
            var currency = (0,wrappedCurrency/* unwrappedToken */.Bv)(token);
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            ml: "0.125rem",
                            mr: "0.125rem",
                            children: currency.symbol
                        })
                    }),
                    !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                        width: "12px"
                    })
                ]
            }, i));
        })
    });
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/FormattedPriceImpact.tsx




/**
 * Formatted version of price impact text with warning colors
 */ function FormattedPriceImpact(param) {
    var priceImpact = param.priceImpact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
        fontSize: "14px",
        severity: (0,exchange/* warningSeverity */.oX)(priceImpact),
        children: priceImpact ? priceImpact.lessThan(constants_exchange/* ONE_BIPS */.IS) ? "<0.01%" : "".concat(priceImpact.toFixed(2), "%") : "-"
    });
}

// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(17204);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var tokens_src = __webpack_require__(32521);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./src/config/constants/tokenLists/noah-default.tokenlist.json
var noah_default_tokenlist = __webpack_require__(21961);
// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
;// CONCATENATED MODULE: ./src/views/Swap/index.tsx
/* eslint-disable */ 







function Swap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: bold;\n  color: #4c4c4c;\n"
    ]);
    Swap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Swap_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent !important;\n  &:hover {\n    opacity: 1 !important;\n  }\n"
    ]);
    Swap_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Swap_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48%;\n  display: flex;\n  border-radius: 6px;\n  cursor: pointer;\n  // justify-content: center;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-direction: column;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 15px;\n  // padding: ",
        ";\n  // height: 112px;\n  // justify-content: flex-start;\n  &:hover {\n    // background-color: #fff;\n  }\n"
    ]);
    Swap_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Swap_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // padding: ",
        ";\n  .label {\n    color: #999;\n    font-size: 14px;\n    margin-bottom: 10px;\n  }\n  .value {\n    color: #000;\n    font-size: ",
        ";\n    font-weight: bold;\n  }\n"
    ]);
    Swap_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















// import { useCommonTokens } from 'hooks/useCommonTokens'















// import { useGasPriceManager, useDefaultGasPrice } from 'state/user/hooks'
// import { GAS_PRICE_GWEI, GAS_PRICE } from 'state/types'




// eslint-disable-next-line


// import PriceChartContainer from './components/Chart/PriceChartContainer'















var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3ad0bd75-0"
})(Swap_templateObject());
var SwitchIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-3ad0bd75-1"
})(Swap_templateObject1());
var ButtonStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ad0bd75-2"
})(Swap_templateObject2(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "10px 10px" : "10px 24px";
});
var TopBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3ad0bd75-3"
})(Swap_templateObject3(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "10px 10px" : "10px 24px";
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "18px" : "20px";
});
// const CHART_SUPPORT_CHAIN_IDS = [ChainId.EVM]
// const SettingsModalWithCustomDismiss = withCustomOnDismiss(SettingsModal)
function Swap() {
    var enumKeys = function enumKeys(obj) {
        return Object.keys(obj).filter(function(k) {
            return Number.isNaN(+k);
        });
    };
    var listToTokenMap = function listToTokenMap(list) {
        // const result = listCache?.get(list)
        // if (result) return results
        var tokenMap = uniqBy_default()(list.tokens, function(tokenInfo) {
            return "".concat(tokenInfo.chainId, "#").concat(tokenInfo.address);
        }).map(function(tokenInfo) {
            var ref, ref1;
            var ref2;
            var tags = (ref2 = (ref1 = (ref = tokenInfo.tags) === null || ref === void 0 ? void 0 : ref.map(function(tagId) {
                var ref;
                if (!((ref = list.tags) === null || ref === void 0 ? void 0 : ref[tagId])) return undefined;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, list.tags[tagId]), {
                    id: tagId
                });
            })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(x) {
                return Boolean(x);
            })) !== null && ref2 !== void 0 ? ref2 : [];
            return new tokens_src/* WrappedTokenInfo */.DT(tokenInfo, tags);
        });
        var groupedTokenMap = groupBy_default()(tokenMap, function(tokenInfo) {
            return tokenInfo.chainId;
        });
        // console.log(groupedTokenMap, 'groupedTokenMapgroupedTokenMap')
        var tokenAddressMap = fromPairs_default()(Object.entries(groupedTokenMap).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), chainId = _param[0], tokenInfoList = _param[1];
            return [
                chainId,
                fromPairs_default()(tokenInfoList.map(function(tokenInfo) {
                    return [
                        tokenInfo.address,
                        {
                            token: tokenInfo,
                            list: list
                        }
                    ];
                })), 
            ];
        }));
        // add chain id item if not exist
        enumKeys(src/* ChainId */.a_).forEach(function(chainId) {
            if (!(src/* ChainId */.a_[chainId] in tokenAddressMap)) {
                Object.defineProperty(tokenAddressMap, src/* ChainId */.a_[chainId], {
                    value: {}
                });
            }
        });
        listCache === null || listCache === void 0 ? void 0 : listCache.set(list, tokenAddressMap);
        return tokenAddressMap;
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var router = (0,next_router.useRouter)();
    // 默认选中币种
    var loadedUrlParams = (0,swap_hooks/* useDefaultsFromURLSearch */.jj)();
    // const [gasPriceAll, setGasPriceAll] = useState({
    //   default: GAS_PRICE.default,
    // })
    // const [gasPrice, setGasPrice] = useGasPriceManager()
    // if (Number(gasPrice) < 900000000000) {
    //   setGasPrice(GAS_PRICE_GWEI.rpcDefault)
    // }
    // const defaultGasPrice = useDefaultGasPrice()
    // // console.log('首页defaultGasPrice', defaultGasPrice)
    // useEffect(() => {
    //   if (defaultGasPrice) {
    //     setGasPriceAll((prevGasPrice) => ({
    //       ...prevGasPrice,
    //       default: defaultGasPrice,
    //     }))
    //   }
    // }, [defaultGasPrice])
    var ref15 = (0,localization_src/* useTranslation */.$G)(), t = ref15.t, _currentLanguage = ref15.currentLanguage, langCode = _currentLanguage.code;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref16 = (0,react.useState)(false), isChartExpanded = ref16[0], setIsChartExpanded = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExchangeChartManager */.vD)(isMobile), 2), userChartPreference = ref17[0], setUserChartPreference = ref17[1];
    var ref18 = (0,react.useState)(userChartPreference), isChartDisplayed = ref18[0], setIsChartDisplayed = ref18[1];
    var ref19 = hooks_useRefreshBlockNumber(), refreshBlockNumber = ref19.refreshBlockNumber, isLoadings = ref19.isLoading;
    (0,react.useEffect)(function() {
        setUserChartPreference(isChartDisplayed);
    }, [
        isChartDisplayed,
        setUserChartPreference
    ]);
    var listCache = typeof WeakMap !== "undefined" ? new WeakMap() : null;
    var mapWithoutUrls = function(tokenMap, chainId) {
        return Object.keys(tokenMap && tokenMap[chainId] || {}).reduce(function(newMap, address) {
            // eslint-disable-next-line no-param-reassign
            newMap[address] = tokenMap[chainId][address].token;
            return newMap;
        }, {});
    };
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId')) || 17777
    // const userAddedTokens = useUserAddedTokens()
    var ref20 = (0,react.useState)({}), listData = ref20[0], setListData = ref20[1];
    var ref21 = (0,chainUtils/* default */.Z)(), baseURL = ref21.baseURL, chainid = ref21.chainid;
    var ref22 = (0,react.useState)(0), tvl = ref22[0], setTvl = ref22[1];
    var ref23 = (0,react.useState)(0), volume = ref23[0], setVolume = ref23[1];
    (0,react.useEffect)(function() {
        // console.log('我是正常的打印🤖🤖🤖🤖🤖🤖', router, isMobile)
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var defaultList, ref, data, code, formatData, defaultTokenMap, listDatas;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            defaultList = noah_default_tokenlist;
                            return [
                                4,
                                (0,service/* getRecommendCoin */.xH)({
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, code = ref.code;
                            formatData = [];
                            if (!code) {
                                // console.log('🧚🏼‍♂️🧚🏼‍♂️🧚🏼‍♂️🧚🏼‍♂️🧚🏼‍♂️🧚🏼‍♂️🧚🏼‍♂️请求GetCoinList')
                                formatData = (data === null || data === void 0 ? void 0 : data.map(function(v) {
                                    var vv = v;
                                    var decimal = vv.decimal;
                                    delete vv.decimal;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, vv), {
                                        decimals: decimal,
                                        chainId: vv.chain_id,
                                        logoURI: "",
                                        address: vv.contract
                                    });
                                })) || [];
                                defaultList.tokens = (0,_to_consumable_array/* default */.Z)(formatData);
                                defaultTokenMap = listToTokenMap(defaultList);
                                listDatas = mapWithoutUrls(defaultTokenMap, chainId);
                                // console.log('最新的', listDatas)
                                setListData(listDatas);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    }, []);
    (0,react.useEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, data, code;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,service/* get24HInfo */.$P)({
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), data = ref.data, code = ref.code;
                            if (!code) {
                                setTvl((data === null || data === void 0 ? void 0 : data.quote_coin_balance) || 0);
                                setVolume((data === null || data === void 0 ? void 0 : data.volume_24h) || 0);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        fetch();
    }, []);
    // token warning stuff
    var ref24 = [
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId, listData),
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId, listData), 
    ], loadedInputCurrency = ref24[0], loadedOutputCurrency = ref24[1];
    var ref25;
    var urlLoadedTokens = (0,react.useMemo)(function() {
        var ref;
        return (ref25 = (ref = [
            loadedInputCurrency,
            loadedOutputCurrency
        ]) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
            return c === null || c === void 0 ? void 0 : c.isToken;
        })) !== null && ref25 !== void 0 ? ref25 : [];
    }, [
        loadedInputCurrency,
        loadedOutputCurrency
    ]);
    var ref26 = (0,useActiveWeb3React/* default */.Z)(), account = ref26.account, chainId = ref26.chainId;
    // dismiss warning if all imported tokens are in active lists
    // const defaultTokens = useAllTokens()
    // 获取getCoinList接口
    // const defaultTokens = useCommonTokens()
    // const defaultTokens = {}
    // console.log(useCommonTokens(), 'useCommonTokens()useCommonTokens()')
    // 这个没有用到, 先注释
    // const importTokensNotInDefault =
    //   urlLoadedTokens &&
    //   urlLoadedTokens.filter((token: Token) => {
    //     return !(token.address in defaultTokens) && token.chainId === chainId
    //   })
    // for expert mode
    // 专家模式开关
    var ref27 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), isExpertMode = ref27[0];
    // get custom setting values for user 设置滑点
    var ref28 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref28[0];
    // swap state & price data
    var ref29 = (0,swap_hooks/* useSwapState */.dU)(), independentField = ref29.independentField, typedValue = ref29.typedValue, recipient = ref29.recipient, _INPUT = ref29[actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref29[actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    // 根据address返回对应的币种类
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId, listData);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId, listData);
    // const test = 1
    // console.log('v2Tradev2Tradev2Tradev2Trade', listData);  // 这里的 listData 是最新的数据)
    var ref30 = (0,swap_hooks/* useDerivedSwapInfo */.SM)(independentField, typedValue, inputCurrency, outputCurrency, recipient, listData), v2Trade = ref30.v2Trade, currencyBalances = ref30.currencyBalances, parsedAmount = ref30.parsedAmount, currencies = ref30.currencies, swapInputError = ref30.inputError;
    var ref31 = useWrapCallback(currencies[actions/* Field.INPUT */.gN.INPUT], currencies[actions/* Field.OUTPUT */.gN.OUTPUT], typedValue), wrapType = ref31.wrapType, onWrap = ref31.execute, wrapInputError = ref31.inputError;
    var showWrap = wrapType !== WrapType.NOT_APPLICABLE;
    var trade = showWrap ? undefined : v2Trade;
    var _obj, _obj1;
    var parsedAmounts = showWrap ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, parsedAmount), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, parsedAmount), _obj) : (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, independentField === actions/* Field.INPUT */.gN.INPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.inputAmount), (0,_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, independentField === actions/* Field.OUTPUT */.gN.OUTPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.outputAmount), _obj1);
    // 封装各种swap后的操作
    var ref32 = useSwapActionHandlers(), onSwitchTokens = ref32.onSwitchTokens, onCurrencySelection = ref32.onCurrencySelection, onUserInput = ref32.onUserInput, onChangeRecipient = ref32.onChangeRecipient;
    var isValid = !swapInputError;
    var dependentField = independentField === actions/* Field.INPUT */.gN.INPUT ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
    var handleTypeInput = (0,react.useCallback)(function(value) {
        // console.log('value', value)
        onUserInput(actions/* Field.INPUT */.gN.INPUT, value);
    }, [
        onUserInput
    ]);
    var handleTypeOutput = (0,react.useCallback)(function(value) {
        onUserInput(actions/* Field.OUTPUT */.gN.OUTPUT, value);
    }, [
        onUserInput
    ]);
    // modal and loading
    var ref33 = (0,react.useState)({
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    }), ref34 = ref33[0], tradeToConfirm = ref34.tradeToConfirm, swapErrorMessage = ref34.swapErrorMessage, attemptingTxn = ref34.attemptingTxn, txHash = ref34.txHash, setSwapState = ref33[1];
    var ref35, ref36;
    var _obj2;
    var formattedAmounts = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, independentField, typedValue), (0,_define_property/* default */.Z)(_obj2, dependentField, showWrap ? (ref35 = (ref = parsedAmounts[independentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref35 !== void 0 ? ref35 : "" : (ref36 = (ref1 = parsedAmounts[dependentField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref36 !== void 0 ? ref36 : ""), _obj2);
    // if(formattedAmounts.OUTPUT){
    //   const now = new Date();
    //   const hours = now.getHours().toString().padStart(2, '0');
    //   const minutes = now.getMinutes().toString().padStart(2, '0');
    //   const seconds = now.getSeconds().toString().padStart(2, '0');
    //   const formattedTime = `${hours}:${minutes}:${seconds}`;
    //   console.log(formattedTime + '---得到的值', formattedAmounts.OUTPUT)
    // }
    var route = trade === null || trade === void 0 ? void 0 : trade.route;
    // console.log('routerouterouteroute', route)
    var userHasSpecifiedInputOutput = Boolean(currencies[actions/* Field.INPUT */.gN.INPUT] && currencies[actions/* Field.OUTPUT */.gN.OUTPUT] && ((ref2 = parsedAmounts[independentField]) === null || ref2 === void 0 ? void 0 : ref2.greaterThan(constants_exchange/* BIG_INT_ZERO */.iV)));
    var noRoute = !route;
    // check whether the user has approved the router on the input token
    var ref37 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallbackFromTrade */.re)(trade, allowedSlippage, chainId), 2), approval = ref37[0], approveCallback = ref37[1];
    // check if user has gone through approval process, used to show two step buttons, reset on token change
    var ref38 = (0,react.useState)(false), approvalSubmitted = ref38[0], setApprovalSubmitted = ref38[1];
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    (0,react.useEffect)(function() {
        if (approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [
        approval,
        approvalSubmitted
    ]);
    // 获取input最大值
    var maxAmountInput = (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[actions/* Field.INPUT */.gN.INPUT]);
    var atMaxAmountInput = Boolean(maxAmountInput && ((ref3 = parsedAmounts[actions/* Field.INPUT */.gN.INPUT]) === null || ref3 === void 0 ? void 0 : ref3.equalTo(maxAmountInput)));
    // the callback to execute the swap
    var ref39 = useSwapCallback(trade, allowedSlippage, recipient), swapCallback = ref39.callback, swapCallbackError = ref39.error;
    var ref40 = (0,react.useMemo)(function() {
        return (0,exchange/* computeTradePriceBreakdown */.U7)(trade);
    }, [
        trade
    ]), priceImpactWithoutFee = ref40.priceImpactWithoutFee, realizedLPFee = ref40.realizedLPFee;
    var ref41 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref41[0];
    var handleSwap = (0,react.useCallback)(function() {
        if (!swapCallback) {
            return;
        }
        onPresentConfirmModal();
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm: tradeToConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        });
        swapCallback().then(function(hash) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: undefined,
                txHash: hash
            });
        }).catch(function(error) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: error.message,
                txHash: undefined
            });
        });
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        t
    ]);
    // errors
    var ref42 = (0,react.useState)(false), showInverted = ref42[0], setShowInverted = ref42[1];
    // warnings on slippage
    var priceImpactSeverity = (0,exchange/* warningSeverity */.oX)(priceImpactWithoutFee);
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    var showApproveFlow = !swapInputError && (approval === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING || approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED) && !(priceImpactSeverity > 3 && !isExpertMode);
    var handleConfirmDismiss = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: tradeToConfirm,
            attemptingTxn: attemptingTxn,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash
        });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(actions/* Field.INPUT */.gN.INPUT, "");
        }
    }, [
        attemptingTxn,
        onUserInput,
        swapErrorMessage,
        tradeToConfirm,
        txHash
    ]);
    var handleAcceptChanges = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: trade,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash,
            attemptingTxn: attemptingTxn
        });
    }, [
        attemptingTxn,
        swapErrorMessage,
        trade,
        txHash
    ]);
    // swap warning state
    var ref43 = (0,react.useState)(null), swapWarningCurrency = ref43[0], setSwapWarningCurrency = ref43[1];
    var ref44 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwapWarningModal, {
        swapCurrency: swapWarningCurrency
    }), false), 1), onPresentSwapWarningModal = ref44[0];
    (0,react.useEffect)(function() {
        if (swapWarningCurrency) {
            onPresentSwapWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        swapWarningCurrency
    ]);
    // input选择框回调
    var handleInputSelect = (0,react.useCallback)(function(currencyInput) {
        setApprovalSubmitted(false) // reset 2 step UI for approvals
        ;
        onCurrencySelection(actions/* Field.INPUT */.gN.INPUT, currencyInput);
        var showSwapWarning = utils_shouldShowSwapWarning(currencyInput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyInput);
        } else {
            setSwapWarningCurrency(null);
        }
        (0,replaceBrowserHistory/* default */.Z)("inputCurrency", (0,currencyId/* currencyId */.H)(currencyInput));
    }, [
        onCurrencySelection
    ]);
    var handleMaxInput = (0,react.useCallback)(function(num) {
        // console.log('number', num)
        if (num) {
            onUserInput(actions/* Field.INPUT */.gN.INPUT, num.toExact());
        }
    // if (maxAmountInput) {
    //   console.log('maxAmountInput',  maxAmountInput.toExact())
    //   onUserInput(Field.INPUT, maxAmountInput.toExact())
    // }
    }, [
        maxAmountInput,
        onUserInput
    ]);
    // console.log(maxAmountInput.toExact(), 'maxAmountInput.toExact()')
    // output选择框回调
    var handleOutputSelect = (0,react.useCallback)(function(currencyOutput) {
        onCurrencySelection(actions/* Field.OUTPUT */.gN.OUTPUT, currencyOutput);
        var showSwapWarning = utils_shouldShowSwapWarning(currencyOutput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyOutput);
        } else {
            setSwapWarningCurrency(null);
        }
        (0,replaceBrowserHistory/* default */.Z)("outputCurrency", (0,currencyId/* currencyId */.H)(currencyOutput));
    }, [
        onCurrencySelection
    ]);
    var swapIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.INPUT, currencies === null || currencies === void 0 ? void 0 : currencies.OUTPUT);
    // const swapIsUnsupported = false
    // const [onPresentImportTokenWarningModal] = useModal(
    //   <ImportTokenWarningModal tokens={importTokensNotInDefault} onCancel={() => router.push('/swap')} />,
    // )
    // useEffect(() => {
    //   if (importTokensNotInDefault.length > 0) {
    //     onPresentImportTokenWarningModal()
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [importTokensNotInDefault.length])
    var ref45 = (0,react.useState)(false), indirectlyOpenConfirmModalState = ref45[0], setIndirectlyOpenConfirmModalState = ref45[1];
    // const [onPresentSettingsModal] = useModal(
    //   <SettingsModalWithCustomDismiss
    //     customOnDismiss={() => setIndirectlyOpenConfirmModalState(true)}
    //     mode={SettingsMode.SWAP_LIQUIDITY}
    //   />,
    // )
    var clearInput = function() {
        onUserInput(actions/* Field.INPUT */.gN.INPUT, "");
    };
    var ref46, ref47, ref48, ref49;
    var pendingText = t("Exchange %num1% %coin1% for %num2% %coin2%", {
        num1: (ref46 = trade === null || trade === void 0 ? void 0 : (ref4 = trade.inputAmount) === null || ref4 === void 0 ? void 0 : ref4.toSignificant(6)) !== null && ref46 !== void 0 ? ref46 : "",
        coin1: (ref47 = trade === null || trade === void 0 ? void 0 : (ref5 = trade.inputAmount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currency) === null || ref6 === void 0 ? void 0 : ref6.symbol) !== null && ref47 !== void 0 ? ref47 : "",
        num2: (ref48 = trade === null || trade === void 0 ? void 0 : (ref7 = trade.outputAmount) === null || ref7 === void 0 ? void 0 : ref7.toSignificant(6)) !== null && ref48 !== void 0 ? ref48 : "",
        coin2: (ref49 = trade === null || trade === void 0 ? void 0 : (ref8 = trade.outputAmount) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.currency) === null || ref9 === void 0 ? void 0 : ref9.symbol) !== null && ref49 !== void 0 ? ref49 : ""
    });
    // const [{ successText, failText }, setText] = useState({
    //   successText: t('noah389'),
    //   failText: t('noah390'),
    // })
    var ref50 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(// <ConfirmSwapModal
    //   trade={trade}
    //   originalTrade={tradeToConfirm}
    //   currencyBalances={currencyBalances}
    //   onAcceptChanges={handleAcceptChanges}
    //   attemptingTxn={attemptingTxn}
    //   txHash={txHash}
    //   recipient={recipient}
    //   allowedSlippage={allowedSlippage}
    //   onConfirm={handleSwap}
    //   swapErrorMessage={swapErrorMessage}
    //   customOnDismiss={handleConfirmDismiss}
    //   openSettingModal={onPresentSettingsModal}
    // />,
    /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultModal/* default */.ZP, {
        pendingText: pendingText,
        hash: txHash,
        attemptingTxn: attemptingTxn,
        errorMessage: swapErrorMessage,
        successText: t("noah389"),
        failText: t("noah390"),
        clearInput: clearInput,
        isSuccess: function() {
        // console.log('执行合约成功了')
        // handleAcceptChanges()
        // getDataStart()
        // getData(account)
        }
    }), true, true, "confirmSwapModal"), 1), onPresentConfirmModal = ref50[0];
    (0,react.useEffect)(function() {
        if (indirectlyOpenConfirmModalState) {
            setIndirectlyOpenConfirmModalState(false);
            setSwapState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    swapErrorMessage: undefined
                });
            });
            onPresentConfirmModal();
        }
    }, [
        indirectlyOpenConfirmModalState,
        onPresentConfirmModal
    ]);
    var hasAmount = Boolean(parsedAmount);
    var onRefreshPrice = (0,react.useCallback)(function() {
        if (hasAmount) {
            refreshBlockNumber();
        }
    }, [
        hasAmount,
        refreshBlockNumber
    ]);
    var showRoute = Boolean(trade && trade.route.path.length);
    var slippageAdjustedAmounts = (0,exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    // console.log(slippageAdjustedAmounts, 'slippageAdjustedAmounts')
    // console.log(trade, 'trade')
    // console.log(allowedSlippage, 'allowedSlippage')
    var jumpHref = "https://noah-finance.gitbook.io/noah/security/security-audit";
    if (langCode === "zh-tw") {
        jumpHref = "https://noah-finance.gitbook.io/noah/v/fan-ti/he-yao-an-quan/shen-ji-bao-gao";
    } else if (langCode === "ko") {
        jumpHref = "https://noah-finance.gitbook.io/noah/v/undefined/undefined-1/undefined";
    }
    var ref51, ref52, ref53, ref54, ref55;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        removePadding: isChartExpanded,
        hideFooterOnDesktop: isChartExpanded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                width: isMobile ? "100%" : "436px",
                paddingBottom: isMobile && "200px"
            },
            children: [
                chainId != 7200 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    style: {
                        margin: "0 auto 20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyle, {
                        isMobile: isMobile,
                        style: {
                            width: "100%"
                        },
                        children: [
                            langCode === "zh-tw" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/farms",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ad/tw2.png",
                                    alt: ""
                                })
                            }),
                            langCode === "en" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/farms",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ad/en2.png",
                                    alt: ""
                                })
                            }),
                            langCode === "ko" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/farms",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ad/en2.png",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    marginBottom: "10px",
                                    padding: "0 20px",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                onClick: function() {
                                    window.open("https://bridge.evm.eosnetwork.com/");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "8px",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                children: t("noah211")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/small-img/icon4.png",
                                                style: {
                                                    width: "10px",
                                                    height: "10px"
                                                },
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontSize: "12px",
                                            color: "#0D111C",
                                            children: t("noah204")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                        $isChartExpanded: isChartExpanded,
                        style: {
                            marginBottom: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                            mt: isChartExpanded ? "24px" : "0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App/* AppBody */.j, {
                                noMaxWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    justifyContent: "space-between",
                                    style: {
                                        width: !isMobile && "436px",
                                        margin: "10px auto",
                                        padding: "10px 20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBox, {
                                            isMobile: isMobile,
                                            style: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "label",
                                                    children: "TVL"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "value",
                                                    children: [
                                                        (0,formatInfoNumbers/* formatNumber */.uf)((0,formatBalance/* truncateHasZero */.b9)(tvl, 6), 1),
                                                        " BTC"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBox, {
                                            isMobile: isMobile,
                                            style: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "label",
                                                    children: "24H Volume"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "value",
                                                    children: [
                                                        (0,formatInfoNumbers/* formatNumber */.uf)((0,formatBalance/* truncateHasZero */.b9)(volume, 6), 1),
                                                        " BTC"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                            $isChartExpanded: isChartExpanded,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                                mt: isChartExpanded ? "24px" : "0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                                    noMaxWidth: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CurrencyInputHeader, {
                                            title: t("noah11"),
                                            subtitle: t("noah147"),
                                            setIsChartDisplayed: setIsChartDisplayed,
                                            isChartDisplayed: isChartDisplayed,
                                            hasAmount: hasAmount,
                                            onRefreshPrice: onRefreshPrice,
                                            allowedSlippage: allowedSlippage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                                            id: "swap-page",
                                            style: {
                                                minHeight: "320px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                                    gap: "0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                            label: independentField === actions/* Field.OUTPUT */.gN.OUTPUT && !showWrap && trade ? t("From (estimated)") : t("From"),
                                                            value: formattedAmounts[actions/* Field.INPUT */.gN.INPUT],
                                                            showMaxButton: !atMaxAmountInput,
                                                            currency: currencies[actions/* Field.INPUT */.gN.INPUT],
                                                            onUserInput: handleTypeInput,
                                                            onMax: handleMaxInput,
                                                            onCurrencySelect: handleInputSelect,
                                                            otherCurrency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                            id: "swap-currency-input",
                                                            showCommonBases: true,
                                                            commonBasesType: SearchModal_types/* CommonBasesType.SWAP_LIMITORDER */.L0.SWAP_LIMITORDER,
                                                            listData: listData
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                                                            justify: "space-between",
                                                            style: {
                                                                margin: "-14px 0",
                                                                zIndex: "10"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* AutoRow */.BA, {
                                                                justify: isExpertMode ? "space-between" : "center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchIconButton, {
                                                                    variant: "light",
                                                                    scale: "sm",
                                                                    onClick: function() {
                                                                        setApprovalSubmitted(false) // reset 2 step UI for approvals
                                                                        ;
                                                                        onSwitchTokens();
                                                                        (0,replaceBrowserHistory/* default */.Z)("inputCurrency", outputCurrencyId);
                                                                        (0,replaceBrowserHistory/* default */.Z)("outputCurrency", inputCurrencyId);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/images/small-img/swap.png",
                                                                        width: 42,
                                                                        height: 42,
                                                                        alt: "swap"
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                            value: formattedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                            onUserInput: handleTypeOutput,
                                                            label: independentField === actions/* Field.INPUT */.gN.INPUT && !showWrap && trade ? t("To (estimated)") : t("To"),
                                                            showMaxButton: false,
                                                            currency: currencies[actions/* Field.OUTPUT */.gN.OUTPUT],
                                                            onCurrencySelect: handleOutputSelect,
                                                            otherCurrency: currencies[actions/* Field.INPUT */.gN.INPUT],
                                                            id: "swap-currency-output",
                                                            showCommonBases: true,
                                                            commonBasesType: SearchModal_types/* CommonBasesType.SWAP_LIMITORDER */.L0.SWAP_LIMITORDER,
                                                            listData: listData
                                                        }),
                                                        showWrap ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                                            gap: "7px",
                                                            style: {
                                                                padding: "0 16px",
                                                                marginTop: "1rem"
                                                            },
                                                            children: [
                                                                Boolean(trade) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                            align: "center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: t("noah42")
                                                                                }),
                                                                                isLoadings ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                                    width: "50%",
                                                                                    ml: "10px",
                                                                                    height: "22px"
                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradePrice, {
                                                                                    price: trade === null || trade === void 0 ? void 0 : trade.executionPrice,
                                                                                    showInverted: showInverted,
                                                                                    setShowInverted: setShowInverted
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: t("noah43")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: realizedLPFee ? "".concat(realizedLPFee === null || realizedLPFee === void 0 ? void 0 : realizedLPFee.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol) : "-"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: t("noah44")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (0,formatInfoNumbers/* formatNumber */.uf)((ref51 = (ref10 = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref10 === void 0 ? void 0 : ref10.toSignificant(4)) !== null && ref51 !== void 0 ? ref51 : "-", (ref52 = (ref11 = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref11 === void 0 ? void 0 : ref11.toSignificant(4)) !== null && ref52 !== void 0 ? ref52 : "-") : (0,formatInfoNumbers/* formatNumber */.uf)((ref53 = (ref12 = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref12 === void 0 ? void 0 : ref12.toSignificant(4)) !== null && ref53 !== void 0 ? ref53 : "-", (ref54 = (ref13 = slippageAdjustedAmounts[actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref13 === void 0 ? void 0 : ref13.toSignificant(4)) !== null && ref54 !== void 0 ? ref54 : "-")
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                                    fontSize: "14px",
                                                                                    children: t("noah45")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                                                                                    priceImpact: priceImpactWithoutFee
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                showRoute && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                                    align: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                            fontSize: "14px",
                                                                            children: t("noah46")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRoute, {
                                                                            trade: trade
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "EOS" && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "WEOS" || (inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "WEOS" && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "EOS") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        textAlign: "center",
                                                        marginTop: "10px",
                                                        fontSize: "14px",
                                                        lineHeight: "20px"
                                                    },
                                                    children: t("The exchange rate between %coin1% and %coin2% is always 1:1 without any transaction fees.", {
                                                        coin1: "WEOS",
                                                        coin2: "EOS"
                                                    })
                                                }),
                                                ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "BTC" && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "XBTC" || (inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "XBTC" && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "BTC") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        textAlign: "center",
                                                        marginTop: "10px",
                                                        fontSize: "14px",
                                                        lineHeight: "20px"
                                                    },
                                                    children: t("The exchange rate between %coin1% and %coin2% is always 1:1 without any transaction fees.", {
                                                        coin1: "XBTC",
                                                        coin2: "BTC"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    mt: "1rem",
                                                    children: [
                                                        swapIsUnsupported ? // 不受支持的资产
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            width: "100%",
                                                            disabled: true,
                                                            children: t("noah143")
                                                        }) : !account ? // 连接钱包
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                                            width: "100%"
                                                        }) : showWrap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                            width: "100%",
                                                            disabled: Boolean(wrapInputError),
                                                            onClick: onWrap,
                                                            children: !parsedAmount ? t("noah144") : t("noah11")
                                                        }) : noRoute && userHasSpecifiedInputOutput ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* GreyCard */.h2, {
                                                            style: {
                                                                textAlign: "center",
                                                                padding: "0.75rem"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                color: "textSubtle",
                                                                children: t("noah150")
                                                            })
                                                        }) : showApproveFlow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                                    variant: approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? "success" : "primary",
                                                                    onClick: approveCallback,
                                                                    disabled: approval !== useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalSubmitted,
                                                                    width: "48%",
                                                                    children: approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                                                        gap: "6px",
                                                                        justify: "center",
                                                                        children: [
                                                                            t("noah151"),
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {
                                                                                stroke: "white"
                                                                            })
                                                                        ]
                                                                    }) : approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? // 批准
                                                                    t("noah54") : "".concat(t("noah54"), " ").concat((ref55 = (ref14 = currencies[actions/* Field.INPUT */.gN.INPUT]) === null || ref14 === void 0 ? void 0 : ref14.symbol) !== null && ref55 !== void 0 ? ref55 : "")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                                    onClick: function() {
                                                                        if (priceImpactSeverity > 4) {
                                                                            setSwapState({
                                                                                tradeToConfirm: trade,
                                                                                attemptingTxn: false,
                                                                                swapErrorMessage: undefined,
                                                                                txHash: undefined
                                                                            });
                                                                            onPresentConfirmModal();
                                                                        } else {
                                                                            handleSwap();
                                                                        }
                                                                    },
                                                                    width: "48%",
                                                                    id: "swap-button",
                                                                    disabled: !isValid || approval !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED,
                                                                    children: t("noah11")
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                                                            variant: isValid && priceImpactSeverity > 2 && !swapCallbackError ? "primary" : "primary",
                                                            isLoading: attemptingTxn,
                                                            onClick: function() {
                                                                if (priceImpactSeverity > 4) {
                                                                    setSwapState({
                                                                        tradeToConfirm: trade,
                                                                        attemptingTxn: false,
                                                                        swapErrorMessage: undefined,
                                                                        txHash: undefined
                                                                    });
                                                                    onPresentConfirmModal();
                                                                } else {
                                                                    handleSwap();
                                                                }
                                                            },
                                                            id: "swap-button",
                                                            width: "100%",
                                                            // disabled={!isValid || (priceImpactSeverity > 3 && !isExpertMode) || !!swapCallbackError}
                                                            disabled: !isValid || !!swapCallbackError,
                                                            children: swapInputError || t("noah11")
                                                        }),
                                                        isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                                                            error: swapErrorMessage
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: jumpHref,
                    target: "_blank",
                    style: {
                        display: "block",
                        textAlign: "center",
                        margin: "25px auto 0",
                        color: "#999",
                        fontSize: isMobile ? "13px" : "14px",
                        lineHeight: "20px"
                    },
                    rel: "noreferrer",
                    children: chainId != 7200 ? t("noah135") : t("noah613")
                })
            ]
        })
    });
}


/***/ })

}]);